<template>
    <div class="container">
        <h2 class="profile-page-title">
            {{ $t('today_lessons') }}
            <span class="profile-page-title__count">({{ lessons.length }})</span>
        </h2>

        <div class="row">
            <div class="col-12">
                <TimetableNotice/>
            </div>
        </div>

        <div class="row pt-2 pb-5" v-if="lessons.length">
            <div v-for="item in lessons" :key="item.id" class="col-12">
                <Lesson :lesson="item"/>
            </div>
        </div>
        <div v-if="timetables && timetables.length > 0" class="text-center py-3 zapis">
          <router-link
              class="btn mt-2 mb-1 demo-button btn-default"
              :to="{ name: 'check' }"
          >
            Проверить доступ к онлайн-классу
          </router-link>
        </div>

        <h2 class="profile-page-title">
            {{ $t('my_timetables') }}
            <span class="profile-page-title__count">({{ timetables.length }})</span>
        </h2>

        <div v-for="item in timetables" :key="item.id" class="row mb-lg-5 active-timetables">
            <div class="col-12">
                <TimetableItem :timetable="item"
                               :subscriptions="item.prolongSubscriptions"
                               :crm-subscriptions="item.subscriptions"
                               @order="order" @more="more" @bonusCourseClick="bonusCourseClick"
                               @uncheck-recurrent="confirmRemoveRecurrent"/>
            </div>
        </div>

        <div
                class="text-center pt-5 pb-8"
                v-if="timetables.length < 1"
        >
            <p class="h2">{{ $t('my_timetables_empty') }}</p>
            <router-link
                    v-if="flavorConfig.showLinkToTimetablesAtProfile"
                    class="btn btn-default"
                    :to="{ name: 'schedule' }"
            >
                {{ $t('select_timetable') }}
            </router-link>
        </div>

        <modal
                :show="confirmDialog"
        >
            <template v-slot:header>
                <h2>{{ $t('do_you_really_want_to_dismiss_reccurent') }}</h2>
            </template>
            <p>{{ $t('dismiss_reccurent_notice') }}</p>
            <template v-slot:footer>
                <base-button type="secondary" @click="confirmDialog = false" :disabled="loading">{{ $t('cancel') }}</base-button>
                <base-button type="danger" @click="removeRecurrent" :disabled="loading">{{ $t('refuse') }}</base-button>
            </template>
        </modal>
    </div>
</template>

<script>
    import userApi from "../../../data/UserApi";
    import moment from 'moment';
    import Lesson from "../lessons/Lesson";
    import timetableApi from "../../../data/TimetablesApi";
    import subscriptionApi from "../../../data/SubscriptionApi";
    import TimetableItem from "./TimetableItem";
    import TimetableNotice from "./TimetableNotice";

    export default {
        name: 'Browse',
        components: {TimetableNotice, TimetableItem, Lesson},
        data() {
            return {
                timetables: [],
                lessons: [],

                userSubscriptions: [],
                confirmDialog: false,
                removeTimetable: null,
                error: null,
                loading: false,
            }
        },

        computed: {
            activeTimetables() {
                return this.timetables.filter(t => {
                    return t.status === 1
                })
            }
        },

        created() {
            moment.locale(this.$i18n.locale)
            this.fetchTimetables()

            let today = moment().format('YYYY-MM-DD')
            let tomorrow = moment().add(1, 'days').format('YYYY-MM-DD')
            timetableApi.fetchMyTimetableByDates(today, tomorrow, 1)
                .then(async response => {
                    let rawLessons = response;
                    rawLessons.sort((a, b) => a.dateStart.localeCompare(b.dateStart))
                    this.lessons = rawLessons
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })

        },

        filters: {
            formatDate: function (value) {
                return moment(value).format('DD MMMM YYYY')
            }
        },

        methods: {
            fetchTimetables() {
                userApi.fetchTimetables()
                    .then(response => {
                        this.timetables = response;
                    });
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },

            prolong() {

            },

            order(subscription, timetable) {
                if (subscription.stype === 'OnlineTeacher Group')
                    this.$router.push('/subscription/order/' + subscription.idsubscription + '/' + timetable.id)
                else
                    this.$router.push('/subscription/order/' + subscription.idsubscription)
            },

            more(timetable) {
                this.$router.push('/user/profile/timetables/' + timetable.id)
            },

            bonusCourseClick(subscription) {
                if (subscription.courses && subscription.courses.length > 0) {
                    this.$router.push('/course/' + subscription.courses[0].slug)

                }
            },

            confirmRemoveRecurrent(timetable) {
                this.removeTimetable = timetable
                this.confirmDialog = true
            },

            removeRecurrent() {
                if (this.removeTimetable) {
                    this.loading = true
                    this.confirmDialog = false
                    subscriptionApi.removeTimetableRecurrent(this.removeTimetable.id)
                        .then(response => {
                            this.fetchTimetables()
                        })
                        .catch(error => {
                            let data = error.response.data
                            this.error = this.pretty(data)
                            this.loading = false
                        })
                }
            }
        },
    }
</script>

<style>
    #app {
        overflow: hidden;
    }

    @media (max-width: 991.8px) {
        .active-timetables {

        }
    }

    .profile-page-title__count {
        color: #c0c0c0;
        font-size: 1rem;
    }

    /* cards */
    .course-card {
        border: 1px solid #d7e0e5;
        border-radius: 6px;
        margin-bottom: 30px;
        padding: 20px;
        position: relative;
    }

    .course-card-title {
        display: block;
        font-family: 'Manrope Bold', 'Open Sans', sans-serif;
        line-height: 1.4;
    }

    .course-card-title__language {
        color: #c0c0c0;
    }

    .course-card__button {
        border-radius: 18px;
        color: #fff !important;
        font-family: 'Manrope Bold', 'Open Sans', sans-serif;
    }

    .course-card__button--red {
        background-color: #f15a21;
    }

    .course-card__description,
    .course-card__description p {
        color: #999 !important;
        font-size: .9rem !important;
        line-height: normal;
    }

    .course-card-title {
        font-size: 20px;
    }

    .time-notice {
        color: #ed1c24;
        font-size: 15px;
        font-family: "Manrope Bold";
    }

    .btn-prolong {
        width: 300px;
        margin: 0 auto;
        background: #ed1c24;
        padding: 10px 15px;
        min-width: 150px;
        border-radius: 18px;
        color: #fff;
        font-family: Manrope Bold;
        font-size: 18px;
        text-shadow: 1px 2px 1px rgba(0, 0, 0, 0.75);
        box-shadow: 1px 1px 3px 0 rgba(40, 40, 40, 1);
        border: none;
    }
</style>
